export default __webpack_public_path__ + "static/logo_azerpost-2x-28e07c7b01ddadb4fdda94a63b8d5403.png";